import { useIonModal } from '@ionic/react'
import { OverlayEventDetail } from '@ionic/react/dist/types/components/react-component-lib/interfaces'
import classNames from 'classnames'
import { ReactNode, useEffect, useRef, useState } from 'react'

import { ImageComponent } from '@apps-common/components/common/Image'
import { CropperModal } from '@apps-common/components/modals/CropperModal'
import { ModalDismiss } from '@apps-common/config/modal'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { convertBase64ImageToBlob } from '@apps-common/utils/base64ImageToBlob'

const IMAGE_SELECT_FILE_TYPES = 'image/png, image/gif, image/jpeg'

interface IProps {
  outerClasses?: string
  existingImageUrl?: string
  containerClasses?: string
  selectedImageClasses?: string
  clearClasses?: string
  existingClasses?: string
  cropDimensions?: { width: number; height: number }
  children: ReactNode
  clearChildren: ReactNode
  disabled?: boolean
  onChangeCallback: (data: any) => void
  onClearCallback: (data: any) => void
}

export const ImageSelect = ({
  outerClasses,
  existingImageUrl,
  containerClasses = '',
  selectedImageClasses,
  clearClasses = '',
  existingClasses,
  cropDimensions,
  children,
  clearChildren,
  disabled,
  onChangeCallback,
  onClearCallback
}: IProps) => {
  const inputFileRef = useRef<any>(null)
  const [file, setFile] = useState<File | null>()
  const [croppedImage, setCroppedImage] = useState<any | null>()

  const [present, dismiss] = useIonModal(CropperModal, {
    componentProps: { file, cropDimensions },
    onDismiss: (data: string, role: string) => dismiss(data, role),
    modalSlideUpEnterAnimation,
    modalSlideUpLeaveAnimation
  })

  const activateFileSelect = () => {
    inputFileRef?.current?.click()
  }
  const clear = () => {
    onClearCallback(croppedImage)
    if (inputFileRef?.current) {
      inputFileRef.current.value = ''
    }
    setFile(null)
    setCroppedImage(null)
  }

  const onFileChange = (e: any) => {
    const targetFiles: File[] = Array.from(e.target.files)

    if (targetFiles?.length > 0) {
      setFile(targetFiles[0])
    }
  }

  useEffect(() => {
    if (file) {
      // if (cropDimensions) {
      present({
        onDidDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
          if (ev.detail.role === ModalDismiss.Confirm) {
            let data: any = null

            try {
              data = convertBase64ImageToBlob(ev.detail.data || '')
            } catch {
              // failed to parse data from modal
            }
            setCroppedImage(data)
            onChangeCallback(data)
          } else if (ev.detail.role === ModalDismiss.Cancel) {
            onChangeCallback(null)
          }
        }
      })
      // } else {
      //   onChangeCallback(file)
      // }
    }

    onChangeCallback(null)
  }, [file])

  return (
    <>
      <div className={classNames(outerClasses, 'relative')}>
        {(croppedImage || existingImageUrl) && (
          <button type='button' className={clearClasses} onClick={clear}>
            {clearChildren}
          </button>
        )}
        <button type='button' className={classNames(containerClasses)} onClick={activateFileSelect}>
          {!croppedImage && !existingImageUrl && children}
          {!croppedImage && existingImageUrl && (
            <ImageComponent
              src={existingImageUrl}
              alt='Existing item'
              imageClasses={existingClasses || ''}
              errorIconClasses={existingClasses || ''}
            />
          )}
          {croppedImage && (
            <img className={selectedImageClasses || existingClasses} src={URL.createObjectURL(croppedImage?.blob)} alt='Selected file' />
          )}
        </button>
      </div>
      <input
        ref={inputFileRef}
        type='file'
        accept={IMAGE_SELECT_FILE_TYPES}
        multiple={false}
        onChange={onFileChange}
        disabled={disabled}
        onClick={() => {
          if (inputFileRef?.current) {
            inputFileRef.current.value = ''
          }
        }}
        className='hidden'
      />
    </>
  )
}
